(() => {
  if (window.Shopify?.designMode || window.__contactKlaviyoTracking) return;
  window.__contactKlaviyoTracking = true;

  const lifetime = 30 * 60 * 1000;
  const initialized = new WeakSet();
  let privacyLoading = false;

  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true;
  };

  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy || privacyLoading || !window.Shopify?.loadFeatures) return;
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {
        privacyLoading = false;
      });
    } catch {
      privacyLoading = false;
    }
  };

  const initialize = () => {
    document.querySelectorAll('[data-klaviyo-contact]').forEach((marker, index) => {
      const form = marker.closest('form');
      if (!form || initialized.has(form)) return;
      initialized.add(form);

      const key = `klaviyo:contact:${location.pathname}:${form.id}:${index}`;
      let successfulId = null;
      let busy = false;
      let completed = false;
      let timer;
      let deadline;

      const clear = () => {
        try {
          sessionStorage.removeItem(key);
        } catch {}
      };

      const read = () => {
        try {
          const record = JSON.parse(sessionStorage.getItem(key));
          if (!record) return null;
          if (
            typeof record.id !== 'string' ||
            typeof record.email !== 'string' ||
            !record.email ||
            !Number.isFinite(record.createdAt) ||
            record.createdAt > Date.now() ||
            Date.now() - record.createdAt > lifetime
          ) {
            clear();
            return null;
          }
          return record;
        } catch {
          clear();
          return null;
        }
      };

      const stop = () => {
        clearTimeout(timer);
        document.removeEventListener('visitorConsentCollected', attempt);
      };

      const attempt = async () => {
        clearTimeout(timer);
        const record = read();
        if (completed || !successfulId || record?.id !== successfulId || Date.now() > deadline) {
          stop();
          return;
        }

        timer = setTimeout(attempt, 500);
        loadPrivacy();
        const client = window.klaviyo;
        if (busy || !allowed() || typeof client?.identify !== 'function' || typeof client?.track !== 'function') return;

        busy = true;
        try {
          await client.identify({ email: record.email });
          if (!allowed() || read()?.id !== successfulId || successfulId !== record.id) return;
          const tracked = await client.track('Submitted Contact Form', {
            $event_id: record.id,
            FormId: form.id,
            PagePath: location.pathname,
          });
          if (tracked === true) {
            completed = true;
            if (read()?.id === record.id) clear();
            stop();
          }
        } catch {
        } finally {
          busy = false;
        }
      };

      form.addEventListener('submit', () => {
        successfulId = null;
        stop();
        const emailInput = form.querySelector('[name="contact[email]"]');
        const privacy = form.querySelector('input[type="checkbox"][name="conditions"]');
        if (!emailInput?.value.trim() || !emailInput.validity.valid || (privacy && !privacy.checked)) {
          clear();
          return;
        }
        try {
          sessionStorage.setItem(key, JSON.stringify({
            id: crypto.randomUUID(),
            email: emailInput.value.trim(),
            createdAt: Date.now(),
          }));
        } catch {
          clear();
        }
      }, true);

      if (marker.dataset.postedSuccessfully !== 'true') {
        clear();
        return;
      }

      successfulId = read()?.id || null;
      if (!successfulId) return;
      deadline = Date.now() + 120000;
      document.addEventListener('visitorConsentCollected', attempt);
      attempt();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
